import { Avatar, AvatarProps, ElementProps } from '@mantine/core';

type UserAvatarProps = AvatarProps &
  ElementProps<'div', keyof AvatarProps> & {
    displayName?: string;
    photoURL?: string;
  };

/**
 * A person's avatar, wherever one is shown: their photo, else their initials,
 * else Mantine's person placeholder.
 *
 * The placeholder is the point of having this in one place. Avatars used to
 * fall back to a literal "?", which reads as "who is this?" rather than
 * "no photo yet" — and every surface spelled that fallback out for itself, so
 * they drifted apart. Accounts created with an email and password have no
 * name or picture from their sign-in provider, so this is what they show
 * until they set one in Preferences.
 */
export const UserAvatar = ({ displayName, photoURL, ...props }: UserAvatarProps) => (
  <Avatar src={photoURL} name={displayName?.trim() || undefined} radius="xl" {...props} />
);
